export const accountShortLabel = (name, accountNo) => `${name} - ${accountNo.substr(-4)}`;
